var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageCropSquareMask = function SvgImageCropSquareMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image-crop-square-mask_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 335 335",
    style: {
      enableBackground: "new 0 0 335 335"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".image-crop-square-mask_svg__st0{clip-path:url(#image-crop-square-mask_svg__SVGID_00000017482809226213832570000015051318298674098832_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "image-crop-square-mask_svg__SVGID_1_",
    d: "M0 0h335v335H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "image-crop-square-mask_svg__SVGID_00000023992001998091295250000004505735294696678019_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-crop-square-mask_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#image-crop-square-mask_svg__SVGID_00000023992001998091295250000004505735294696678019_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0v40C0 17.9 17.9 0 40 0zm255 0c22.1 0 40 17.9 40 40V0h-40zm40 295c0 22.1-17.9 40-40 40h40v-40zM40 335c-22.1 0-40-17.9-40-40v40h40z",
    style: {
      opacity: 0.6,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#061b09",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 1h255c21.5 0 39 17.5 39 39v255c0 21.5-17.5 39-39 39H40c-21.5 0-39-17.5-39-39V40C1 18.5 18.5 1 40 1z",
    style: {
      fill: "none",
      stroke: "#e7ece9",
      strokeWidth: 2
    }
  })));
};
export default SvgImageCropSquareMask;